import { ButtonProps } from '@chakra-ui/react';
import { useState } from 'react';

import Button from '../../../../../../components/ui/buttons/Button';
import { BuyoutOverlaySource } from '../../../../../../services/analytics/marketplaceEvents';
import BuyoutCallModal from './BuyoutCallModal';

type ExploreBuyoutButtonProps = ButtonProps & {
  source: BuyoutOverlaySource;
  model?: string | null;
  dealId: string;
  leadId: string;
};

const ExploreBuyoutButton = ({
  source,
  model,
  dealId,
  leadId,
  children = 'Explore your buyout',
  ...buttonProps
}: ExploreBuyoutButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        variant="blueOutline"
        size="sm"
        h="36px"
        px="18px"
        {...buttonProps}
      >
        {children}
      </Button>
      <BuyoutCallModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        source={source}
        model={model}
        dealId={dealId}
        leadId={leadId}
      />
    </>
  );
};

export default ExploreBuyoutButton;
